import angular from 'angular'

angular.module('nominas.informacionfiscal')
  .service('NominasInformacionfiscal', NominasInformacionfiscal);

function NominasInformacionfiscal($http) {
  this.get = get;

  function get(id_proyecto, ejercicio, periodo) {
    return $http.get('/kendu/proyectos/proyecto/documentos/informacionfiscal', {
      params: {id_proyecto: id_proyecto, ejercicio: ejercicio, periodo: periodo},
    });
  }
}



// WEBPACK FOOTER //
// ./src/nominas/informacionfiscal/services/NominasInformacionfiscal.js